// extracted by css-extract-rspack-plugin
export default {"bordered":"PjcPL"};